import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { getCurrentMomentYear, handleMktAnalytics } from '../AmexUtils';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../constants';
import './AmexFooter.scss';

const AmexFooter = (
  {
    baseRequestUrl,
    footerConfig,
    awsFolderName,
    Analytics,
  }
) => {
  if (!footerConfig) return null;
  const {
    copyright = '',
    logo,
    logo_aria: logoAria = '',
    logo_headline: logoHeadline,
    links,
    footer_aria: footerAria = '',
  } = footerConfig;
  const primaryLinks = links?.primary_links;

  const renderCopyright = () => {
    const copyWithCurrYear = copyright?.replace('{currentYear}', getCurrentMomentYear());
    const sanitizedCopyWithCurrYear = sanitizeString(copyWithCurrYear);
    return (
      <p
        className="AmexFooter__copyright"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: sanitizedCopyWithCurrYear,
        }}
      />
    );
  };

  const displayLinks = (link) => {
    const { label, url } = link;
    const extraParams = {
      item_name: label,
      action_name: 'Footer Link Click',
    };

    if (!label || !url) return null;
    return (
      <li key={label} className="AmexFooter__link">
        <Link
          href={url}
          target="_self"
          onClick={() => handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParams)}
        >
          {label}
        </Link>
      </li>
    );
  };

  return (
    <footer className="container" aria-label={footerAria}>
      <div className="AmexFooter">
        <h2 className="AmexFooter__logo">
          <span>
            <img
              alt={logoAria}
              src={`${baseRequestUrl}${awsFolderName}/logos/${logo}`}
            />
            <span className="AmexFooter__logo--headline">{logoHeadline}</span>
          </span>
        </h2>
        <nav>
          <ul className="AmexFooter__primary-nav">
            {primaryLinks?.map((link) => displayLinks(link))}
          </ul>
        </nav>
        {copyright && renderCopyright()}
      </div>
    </footer>
  );
};

AmexFooter.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  footerConfig: PropTypes.shape({
    copyright: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    logo_aria: PropTypes.string.isRequired,
    logo_headline: PropTypes.string.isRequired,
    links: PropTypes.shape({
      primary_links: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      event_tag: PropTypes.string.isRequired,
    }),
    footer_aria: PropTypes.string.isRequired,
  }).isRequired,
  awsFolderName: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexFooter;
